import {gql} from '@apollo/client'

export const MOVE_ITEMS = gql`
  mutation MoveItems($input: MoveItemsInput!) {
    moveItems(input: $input) {
      folderIds
      uploadIds
    }
  }
`
